<footer class="site-footer">

  <ng-container *ngIf="(lodgeDetails$ | async) || defaultLodge as lodge">

    <div class="footer-inner">

      <section class="footer-brand">

        <a [routerLink]="['/home']" class="footer-logo-link">

          <img
            src="assets/images/logo.png"
            [alt]="(lodge.name || 'Safarizine') + ' - Safari and Nature Experience'"
            class="footer-logo-img" />

        </a>

        <p>
          {{
            lodge.short_desc
            || 'A calm lodge base for wildlife stays, family breaks, and guided nature escapes.'
          }}
        </p>

      </section>

      <section>

        <h3>Explore</h3>

        <a
          *ngFor="let item of quickLinks"
          [routerLink]="item.url">

          {{ item.title }}

        </a>

      </section>

      <section>

        <h3>Guest Info</h3>

        <a
          *ngFor="let item of policyLinks"
          [routerLink]="item.url">

          {{ item.title }}

        </a>

      </section>

      <section>

        <h3>Booking Desk</h3>

        <p>
          Open daily for room, safari, and pickup enquiries.
        </p>

        <a
          routerLink="/contact"
          class="footer-cta-button">

          Send Enquiry

        </a>

      </section>

    </div>

    <div class="footer-bottom">

      <span>
        Copyright {{ year }}
        {{ lodge.name || 'Safarizine' }}.
        All rights reserved.
      </span>

      <span class="developer-credit">
        Developed by
        <a href="https://thefoxlab.com/" target="_blank" rel="noopener">
          TheFoxLab.com
        </a>
      </span>

    </div>

  </ng-container>

</footer>
